import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ContentText' })
export class ContentTextPipe implements PipeTransform {
    transform(input: any[], key: string): any {
        const item = input?.find(x => x.contentTextKey.toLowerCase() == key.toLowerCase());
        if (item) {
            return item.contentTextValue ?? key;
        }
        else {
            //console.log('ContentText not found', key);
            return key;
        }
    }
}
